import { render, staticRenderFns } from "./addSection.vue?vue&type=template&id=7b06a471&scoped=true"
import script from "./addSection.vue?vue&type=script&lang=js"
export * from "./addSection.vue?vue&type=script&lang=js"
import style0 from "./addSection.vue?vue&type=style&index=0&id=7b06a471&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b06a471",
  null
  
)

export default component.exports